import { css } from '@emotion/react';
import { css as classCss } from '@emotion/css';
import { lg } from '@editor2/styles/breakpoints';

export const rightPanel = classCss`
	position: fixed;
	top: 0;
	right: 0;
	height: 100%;
	width: 250px;

	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-end;

	padding: 10px 20px;

	.buttonsBlock {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		width: 100%;
	}

	.activeChangesBlock {
		width: 100%;
	}

	.indent {
		margin-top: 0.75em;
	}

	@media (max-width: ${lg}px) {
		position: sticky;
		top: 50px;
		background-color: white;
		width: 100%;
		z-index: 100;
		border-bottom: 1px solid #dee2e6;
		padding: 10px 40px;

		display: flex;
		flex-direction: row-reverse;
		align-items: start;
		justify-content: space-between;

		max-height: 155px;

		.buttonsBlock {
			width: auto;
		}

		.activeChangesBlock {
			overflow-y: auto;
			height: 100%;
			flex: 1;
			padding: 0 15px;
		}

		.activeChangesBlock > div {
			padding: 0;
		}

		.presenceBlock {
			overflow-y: auto;
			height: 100%;
		}
	}
`;

export const appContainer = classCss`
	display: flex;
	padding: 0 0.75em;
`;

export const appGlobalStyles = css`
	// https://fonts.google.com/specimen/JetBrains+Mono?category=Monospace
	@import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:ital@0;1&display=swap');
`;
